import { FormConfig, SelectOption } from '@lbcamden/lib-react';
import { z } from 'zod';

import { personFieldDisplayValues } from '~/client/config/display-values/people';
import { householdMemberUpdateSchema, tenantUpdateSchema } from '~/common/schemas/people';
import { ReferenceListType } from '~/common/types/data';
import { Person } from '~/common/types/people';

export type PersonFormValues = Person;

export type TenantUpdateFormValues = z.infer<typeof tenantUpdateFormSchema>;

export type HouseholdMemberUpdateFormValues = z.infer<typeof householdMemberUpdateFormSchema>;

export type PersonUpdateFormValues = TenantUpdateFormValues | HouseholdMemberUpdateFormValues;

export const tenantUpdateFormSchema = tenantUpdateSchema;

export const householdMemberUpdateFormSchema = householdMemberUpdateSchema.omit({ fullName: true });

export const personFormConfig = (
  referenceListSelectOptions: (type: ReferenceListType) => SelectOption[],
  isTenant?: boolean,
) =>
  ({
    fieldDisplayValues: personFieldDisplayValues,
    fieldSections: [
      {
        title: 'Personal information',
        fields: [
          'title',
          'forename',
          'initials',
          'surname',
          'otherName',
          'dateOfBirth',
          !isTenant && 'relationToTenant',
          'genderAtBirth',
          'gender',
          'maritalStatus',
          'economicStatus',
          'ethnicOrigin',
          'language',
          'sexuality',
          'religion',
          'preferredMethodOfContact',
        ].filter(Boolean) as StringKey<Person>[],
      },
    ],
    fieldConfigs: {
      dateOfBirth: {
        type: 'date',
      },
      title: {
        selectOptions: referenceListSelectOptions('TITLE'),
      },
      relationToTenant: {
        selectOptions: referenceListSelectOptions('RELATION'),
      },
      maritalStatus: {
        selectOptions: referenceListSelectOptions('MAR_STAT'),
        selectionNullable: true,
      },
      gender: {
        selectOptions: referenceListSelectOptions('SEX'),
      },
      economicStatus: {
        selectOptions: referenceListSelectOptions('ECONOMIC_STATUS'),
        selectionNullable: true,
      },
      language: {
        selectOptions: referenceListSelectOptions('SUPPORTED_NLD'),
        selectionNullable: true,
      },
      ethnicOrigin: {
        selectOptions: referenceListSelectOptions('ETHNIC2'),
        selectionNullable: true,
      },
      preferredMethodOfContact: {
        selectOptions: referenceListSelectOptions('PREF_COMM'),
        selectionNullable: true,
      },
      sexuality: {
        selectOptions: referenceListSelectOptions('SEXUAL_ORIENTATION'),
        selectionNullable: true,
      },
      religion: {
        selectOptions: referenceListSelectOptions('RELIGION'),
        selectionNullable: true,
      },
      genderAtBirth: {
        selectOptions: referenceListSelectOptions('GENDER_AT_BIRTH'),
        selectionNullable: true,
      },
    },
  }) satisfies FormConfig<PersonFormValues>;
